/* Filtros pill del catalogo y de noticias — Vendotractos.
 *
 * Filtra tarjetas ya renderizadas por data-categoria / data-tipo (catalogo) o
 * data-tags (noticias). Con 11 unidades y un blog chico no hace falta pedir
 * nada al servidor; si el catalogo crece, esto se cambia por filtros nativos
 * de Shopify sobre metafields.
 */
(function () {
  'use strict';

  function conectar(grupo) {
    var contenedor = grupo.closest('.vt-wrap') || document;
    var rejilla = contenedor.querySelector('[data-vt-rejilla]');
    if (!rejilla) return;
    var vacio = contenedor.querySelector('[data-vt-vacio]');
    var tarjetas = Array.prototype.slice.call(rejilla.children);

    grupo.addEventListener('click', function (evento) {
      var boton = evento.target.closest('button[data-filtro]');
      if (!boton) return;

      var filtro = boton.dataset.filtro;
      grupo.querySelectorAll('button[data-filtro]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === boton));
      });

      var visibles = 0;
      tarjetas.forEach(function (tarjeta) {
        var coincide =
          filtro === 'todos' ||
          tarjeta.dataset.categoria === filtro ||
          tarjeta.dataset.tipo === filtro ||
          (tarjeta.dataset.tags || '').split('|').indexOf(filtro) !== -1;

        // Los tractocamiones tambien son "Carga pesada": al filtrar por pesada
        // se dejan fuera para que los conteos del encabezado cuadren.
        if (filtro === 'Carga pesada' && tarjeta.dataset.tipo === 'Tractocamión') {
          coincide = false;
        }

        tarjeta.hidden = !coincide;
        if (coincide) visibles++;
      });

      if (vacio) vacio.hidden = visibles !== 0;
    });
  }

  document.querySelectorAll('[data-vt-filtros]').forEach(conectar);
})();
